import ShinyHeffers from "./ShinyHeffers";
import ContractAddress from "./ContractAddress";
import Tokenomics from "./Tokenomics";
import GoonSquad from "./GoonSquad";
import WhyInvest from "./WhyInvest";
import RoadMap from "./RoadMap";

const MainView = () => {
  return (
    <>
      <ShinyHeffers />
      <div className="section-divider" />
      <ContractAddress />
      <div className="section-divider" />
      <Tokenomics />
      <div className="section-divider" />
      <GoonSquad />
      <div className="section-divider" />
      <WhyInvest />
      <div className="section-divider" />
      <RoadMap />
    </>
  );
};

export default MainView;
